import { Stack, Typography, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import type { FC } from "react";

type Props = {
	text: string;
	isLast?: boolean;
};

export const FlatRowHint: FC<Props> = ({ text, isLast }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={1}
			px={1.6}
			py={1.25}
			borderBottom={isLast ? "none" : theme.colors.border.flatRowDivider}
		>
			<Info
				size={theme.iconSize.sm}
				color={theme.palette.deprecated.grey[400]}
				style={{ marginTop: 2, flexShrink: 0 }}
			/>
			<Typography
				variant="deprecatedCaption"
				color={theme.palette.deprecated.grey[500]}
			>
				{text}
			</Typography>
		</Stack>
	);
};
